import { type SVGProps } from 'react';
import { type IconProps } from './types';

/** Map pin, used beside a store location (find a location, the location card, the location pill). */
export const MapPinIcon = ({
  title,
  width,
  height,
  ...otherProps
}: Partial<IconProps> & SVGProps<SVGSVGElement>) => (
  <svg
    {...otherProps}
    width={width ?? '16'}
    height={height ?? '16'}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{title ?? 'Pin Icon'}</title>
    <path
      d="M8 8.5C9.10457 8.5 10 7.60457 10 6.5C10 5.39543 9.10457 4.5 8 4.5C6.89543 4.5 6 5.39543 6 6.5C6 7.60457 6.89543 8.5 8 8.5Z"
      stroke="currentColor"
      strokeWidth="0.96875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13 6.5C13 11 8 14.5 8 14.5C8 14.5 3 11 3 6.5C3 5.17392 3.52678 3.90215 4.46447 2.96447C5.40215 2.02678 6.67392 1.5 8 1.5C9.32608 1.5 10.5979 2.02678 11.5355 2.96447C12.4732 3.90215 13 5.17392 13 6.5V6.5Z"
      stroke="currentColor"
      strokeWidth="0.96875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
